const allowedRelativePaths = ["/", "/inactivity-logout", "/signup"];

const getAllowedAbsolutePaths = () =>
  [
    import.meta.env.VITE_PEPPERSTONE_COM_BASE_URL,
    import.meta.env.VITE_PARTNERS_MARKETING_BASE_URL,
  ].filter(Boolean) as string[];

export const validateRedirectUrl = (url: string): string => {
  try {
    const relativePath = url.startsWith(window.location.origin)
      ? url.slice(window.location.origin.length) || "/"
      : url;

    if (relativePath.startsWith("/")) {
      const [path, ...rest] = relativePath.split("?");
      if (!allowedRelativePaths.includes(path)) return "/";
      return rest.length > 0 ? `${path}?${rest.join("?")}` : path;
    }

    const allowedAbsolutePaths = getAllowedAbsolutePaths();
    return allowedAbsolutePaths.includes(url) ? url : "/";
  } catch {
    return "/";
  }
};
